import type { ModelType } from "@/types";

/**
 * The set of behavioral capability flags shown in the model config modals.
 * Single source of truth for the flag list, labels, and descriptions — shared
 * by AddModelModal and ConfigureModelModal via ModelCapabilityFlags.
 */
export interface CapabilityFlag {
  key: ModelCapabilityKey;
  label: string;
  description: string;
}

export type ModelCapabilityKey =
  | "is_reasoning"
  | "supports_vision"
  | "supports_function_calling"
  | "supports_streaming"
  | "supports_code_interpreter";

export const CAPABILITY_FLAGS: CapabilityFlag[] = [
  { key: "is_reasoning", label: "Reasoning Model", description: "No temperature/max_tokens sent" },
  { key: "supports_vision", label: "Vision", description: "Can process images" },
  { key: "supports_function_calling", label: "Function Calling", description: "Supports tool use" },
  { key: "supports_streaming", label: "Streaming", description: "Supports streamed responses" },
  { key: "supports_code_interpreter", label: "Code Interpreter", description: "Supports code_interpreter tool" },
];

/** The behavioral slice of a model form (capability flags + model type). */
export type ModelCapabilityValues = Record<ModelCapabilityKey, boolean> & {
  model_type: ModelType;
};

export const MODEL_TYPE_OPTIONS: { value: ModelType; label: string }[] = [
  { value: "chat", label: "Chat" },
  { value: "embedding", label: "Embedding" },
  { value: "image", label: "Image" },
  { value: "audio", label: "Audio" },
  { value: "research", label: "Research" },
];
